module.exports = __webpack_public_path__ + "img/2@2x.356ba9b5.png";